export var defaultActiveLocale = {
  icon: 'ru',
  srcIcon: '//static.beeline.ru/upload/images/b2c/flags/ru.svg'
};